import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import ReactQuill from "react-quill";
import pageData from "./pageData.json";
import "react-quill/dist/quill.snow.css";
import { IoArrowBackSharp } from "react-icons/io5";

const API_URL = process.env.REACT_APP_API_URL;
// const API_URL = "https://api.solarstation.in"

const AddAds = () => {
    const [formData, setFormData] = useState({
        adType: "google",
        adSlot: "",
        page: "",
        location: "",
        adFormat: "",
        adLayoutKey: "",
        textAlign: "",
        width: "",
        height: "",
        customAdHtml: "",
    });

    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleQuillChange = (value) => {
        setFormData((prev) => ({
            ...prev,
            customAdHtml: value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const response = await fetch(`${API_URL}/ads/createAd`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(formData),
            });

            if (response.ok) {
                alert("Ad created successfully!");
                navigate("/ads");
            } else {
                const errorData = await response.json();
                alert("Error: " + errorData.message);
            }
        } catch (err) {
            console.error("Error creating ad:", err);
            alert("An error occurred while creating the ad.");
        } finally {
            setLoading(false);
        }
    };

    // Determine image preview URL based on selected page and location
    const imagePreviewUrl =
        formData.page && formData.location
            ? pageData[formData.page]?.locations?.[formData.location]
            : null;

    return (
        <>
        <Link to='/ads'><IoArrowBackSharp />
        </Link>
        <div className="max-w-2xl mx-auto p-4">

            <h2 className="text-xl font-bold mb-4">Create New Ad</h2>
            <form onSubmit={handleSubmit} className="grid gap-4">
                <div>
                    <label className="block font-medium mb-1">Ad Type</label>
                    <select
                        name="adType"
                        value={formData.adType}
                        onChange={handleChange}
                        className="w-full border p-2 rounded"
                    >
                        <option value="google">Google</option>
                        <option value="custom">Custom</option>
                        <option value="non">None</option>
                    </select>
                </div>
                <div>
                    <label className="block font-medium mb-1">Page</label>
                    <select
                        name="page"
                        value={formData.page}
                        onChange={handleChange}
                        className="w-full border p-2 rounded"
                        required
                    >
                        <option value="">Select Page</option>
                        {Object.keys(pageData).map((pageKey) => (
                            <option key={pageKey} value={pageKey}>
                                {pageKey}
                            </option>
                        ))}
                    </select>
                </div>

                <div>
                    <label className="block font-medium mb-1">Page Location</label>
                    <select
                        name="location"
                        value={formData.location}
                        onChange={handleChange}
                        className="w-full border p-2 rounded"
                        required
                        disabled={!formData.page}
                    >
                        <option value="">Select Page Location</option>
                        {formData.page &&
                            Object.keys(pageData[formData.page]?.locations || {}).map((loc) => (
                                <option key={loc} value={loc}>
                                    {loc}
                                </option>
                            ))}
                    </select>
                </div>

                {/* 👇 Image Preview Section */}
                {imagePreviewUrl && (
                    <div className="mt-4">
                        <p className="font-medium mb-1">Preview:</p>
                        <img
                            src={imagePreviewUrl}
                            alt="Ad Preview"
                            className="w-full max-w-md rounded border"
                        />
                    </div>
                )}

                {formData.adType === "custom" && (
                    <div>
                        <label className="block font-medium mb-1">Custom Ad HTML</label>
                        <ReactQuill
                            theme="snow"
                            style={{ width: "640px" }}
                            value={formData.customAdHtml}
                            onChange={handleQuillChange}
                            className="bg-white rounded"
                            modules={quillModules}
                            formats={quillFormats}
                        />
                    </div>
                )}

                <button
                    type="submit"
                    disabled={loading}
                    className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition"
                >
                    {loading ? "Submitting..." : "Submit"}
                </button>
            </form>
        </div>
        </>
    );
};

export default AddAds;

const quillModules = {
    toolbar: [
        [{ header: [1, 2, false] }],
        ["bold", "italic", "underline", "strike"],
        [{ color: [] }, { background: [] }],
        [{ align: [] }],
        [{ list: "ordered" }, { list: "bullet" }],
        ["link", "image"],
        ["clean"],
    ],
};

const quillFormats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "color",
    "background",
    "align",
    "list",
    "bullet",
    "link",
    "image",
];
